import { render, staticRenderFns } from "./ProductCategorySub.vue?vue&type=template&id=02472998&"
import script from "./ProductCategorySub.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports